export const SHOP_STAFF_SELECTION = `
    id
    name
    email
    phone
    shop {
        id
        name
        displayedAddress
        streetAddress
        shopDayOff{
            docs {
            id
            date
            value
            }
        }
        avatar {
            url
            alt
        }
        bookingDayOfWeek {
            dayOfWeek
            startTime
            endTime
            timeGap
            bookingNumberLimit
        }
    }
    createdAt
    updatedAt
`;
